import Vue from 'vue';
export default Vue.extend({
    props: {
        withdrawInfo: {
            type: Object,
            default: function () { },
            required: true,
        },
        onWithdrawDone: {
            type: Function,
        },
    },
    data: function () {
        return {
            showingDlg: false,
        };
    },
    methods: {
        closeSelf: function () {
            this.$emit('shut');
        },
        showLoading: function () {
            window.loading = Vue.prototype.$loading({
                spinner: 'el-icon-loading',
                background: 'rgba(300, 300, 300, 0.5)',
                customClass: 'loading',
                body: true,
            });
        },
        hideLoading: function () {
            window.loading && window.loading.close();
        },
        commitWithdraw: function () {
            var _this = this;
            this.showLoading();
            this.launchWithdrawBalanceSettle()
                .then(function (res) {
                _this.hideLoading();
                _this.closeSelf();
                if (res) {
                    _this.$message({
                        message: '撤回成功',
                        type: 'success',
                    });
                    if (_this.onWithdrawDone) {
                        _this.onWithdrawDone();
                    }
                }
            })
                .catch(function () {
                // console.log('catch error')
            });
        },
        launchWithdrawBalanceSettle: function () {
            var params = {
                statementId: this.withdrawInfo.statementId,
                endTime: this.withdrawInfo.endTime,
            };
            return this.$request({
                url: '/proxy/carInsurance/channelBill/disabledStatement',
                method: 'post',
                data: params,
            }).then(function (res) {
                if (!res) {
                    return;
                }
                if (res.errorCode) {
                    return;
                }
                return res;
            });
        },
    },
    created: function () { },
});
